import { render, staticRenderFns } from "./ColumnContainer.vue?vue&type=template&id=39284d16&scoped=true&"
import script from "./ColumnContainer.vue?vue&type=script&lang=ts&"
export * from "./ColumnContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnContainer.vue?vue&type=style&index=0&id=39284d16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39284d16",
  null
  
)

export default component.exports